import API from 'api';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setClientTypes } from 'Reducers/clientTypeReducer';

const useClientTypes = () => {
    const dispatch = useDispatch();
    const clientTypes = useSelector((state) => state.clientTypes.data);
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (clientTypes) return; // Don't fetch again

        // setLoading(true);
        API.client.getAllClientTypes()
            .then((res) => {
                dispatch(setClientTypes(res));
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [clientTypes, dispatch]);

    return { clientTypes, loading, error };
};

export default useClientTypes;
